import React from "react"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"

const pct = (value) => (value == null ? "—" : `${value} %`)

const RetentionCard = ({ data }) => {
  const rows = data || []

  return (
    <ChartCard
      icon     = "arrows-rotate"
      title    = {I18n.t("contracts_dashboard.charts.retention")}
      subtitle = {I18n.t("contracts_dashboard.charts.retention_hint")}
      height   = {280}
      empty    = {rows.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <div className="px-5 py-3 overflow-auto h-full">
        <table className="w-full text-[12px] border-separate" style={{ borderSpacing: "0 2px" }}>
          <thead>
            <tr className="text-slate-500 text-[10px] uppercase tracking-wide align-bottom">
              <th className="text-left  font-semibold pb-2 w-[52px]">{I18n.t("contracts_dashboard.retention.year")}</th>
              <th className="text-right font-semibold pb-2">{I18n.t("contracts_dashboard.retention.base")}</th>
              <th className="text-right font-semibold pb-2">{I18n.t("contracts_dashboard.retention.lost")}</th>
              <th className="text-right font-semibold pb-2 whitespace-nowrap">
                {I18n.t("contracts_dashboard.retention.churn_logo")}
              </th>
              <th className="text-right font-semibold pb-2 whitespace-nowrap">
                {I18n.t("contracts_dashboard.retention.churn_value")}
              </th>
              <th className="text-right font-semibold pb-2 whitespace-nowrap">
                {I18n.t("contracts_dashboard.retention.nrr")}
              </th>
            </tr>
          </thead>
          <tbody className="tabular-nums">
            {rows.map((row) => (
              <tr key={row.year} className="border-t border-slate-100">
                <td className="py-1.5 font-semibold text-slate-900">
                  {row.year}
                  {row.forecast && (
                    <span tooltip={I18n.t("contracts_dashboard.billing.planned")}> ·</span>
                  )}
                </td>
                <td className="py-1.5 text-right text-slate-600">{row.base_count}</td>
                <td className="py-1.5 text-right text-slate-600">{row.lost_count}</td>
                <td className="py-1.5 text-right text-slate-500">{pct(row.churn_logo)}</td>
                <td className={`py-1.5 text-right font-semibold ${row.churn_value > 5 ? "text-rose-600" : "text-slate-700"}`}>
                  {pct(row.churn_value)}
                </td>
                <td className={`py-1.5 text-right font-semibold ${
                  row.nrr == null ? "text-slate-400" : row.nrr >= 100 ? "text-emerald-600" : "text-amber-600"}`}>
                  {pct(row.nrr)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ChartCard>
  )
}

export default RetentionCard
